"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var fa_directive_1 = require("./fa.directive");
var fa_component_1 = require("./fa.component");
//import { FaStackComponent } from './components/fa-stack.component';
var Angular2FontawesomeModule = (function () {
    function Angular2FontawesomeModule() {
    }
    return Angular2FontawesomeModule;
}());
Angular2FontawesomeModule.decorators = [
    { type: core_1.NgModule, args: [{
                imports: [common_1.CommonModule],
                declarations: [fa_directive_1.FaDirective, fa_component_1.FaComponent],
                exports: [fa_directive_1.FaDirective, fa_component_1.FaComponent],
            },] },
];
/** @nocollapse */
Angular2FontawesomeModule.ctorParameters = function () { return []; };
exports.Angular2FontawesomeModule = Angular2FontawesomeModule;



//////////////////
// WEBPACK FOOTER
// ./~/angular2-fontawesome/src/index.js
// module id = 659
// module chunks = 9